import React from "react";
import Sidebar from "./sidebar/Sidebar.jsx";
import DragButton from "./commons/DragButton.jsx";
import Modal from "./commons/Modal.jsx";
import uiActions from "../uiActions.js";
import InterieurDragBox from "../../object3d/InterieurDragBox";
import Fach from "../../object3d/Fach";
// import OcAr from "oc-threejs/ar/oc-ar";
import SidebarMenuItem from "./commons/SidebarMenuItem";
import DeviceDetection from "oc-commons/DeviceDetection";
import Helper from "../../model/Helper";
import Urls from "oc-commons/Urls";

// Wird bald für Facebook 3D Share benötigt
/* import GLTFExporter from "oc-threejs/patched/GLTFExporter.oc.js" */

export default class UI extends React.Component {
    constructor(props) {
        super(props);
        APP.uiHandler.ui = this;
        this.state = {
            model: APP.model,
            sidebar: {
                type: "korpus",
            },
            modal: {},
            topClasses: [],
            showAdditionalIcons: false
        };
        this.toggleAdditionalIcons = this.toggleAdditionalIcons.bind(this);
        this.resetCam = this.resetCam.bind(this);
        // this.arRef = React.createRef();
        /* this.exportGLB = this.exportGLB.bind(this); */
        this.maybeHideSidebar();
    }

    isSmartphoneDisplay() {
        // das hier ist gleich .scss $mobile-breakpoint
        return window.clientWidth < 600;
    }

    maybeHideSidebar() {
        if (!this.isSmartphoneDisplay()) {
            return;
        }
        STAGE.on('drag3dBegin', () => {
            $('#scroll-sidebar').hide();
        });
        STAGE.on('drag3dEnd', () => {
            $('#scroll-sidebar').show();
            this.showSidebar(null);
        });
    }


    updateFromArrangement() {
        this.setState(this.state);
    }

    // Das ist sicher nicht der Weisheit letzter Schluss...
    asset(path) {
        return (
            SETTINGS.wkfgContentBaseUrl + path
        );
    }

    draggable(element, type) {
        const product = APP.productList.filter(p => p.type == type)[0];
        APP.interactionHandler
            .draggable(element)
            .setDragObject3D(handle => APP.model.createDragObject(product));
    }

    removeTopClass(c) {
        this.setState({
            topClasses: this.state.topClasses.filter(cl => cl != c)
        });
    }

    addTopClass(c) {
        this.state.topClasses.push(c);
        this.setState({
            topClasses: this.state.topClasses
        });
    }

    showSidebar(type) {
        if (this.state?.sidebar?.type=='elemente') {
            APP.model.selectElement();
        }
        this.setState({
            sidebar: {
                type: type,
            }
        });
    }

    showModal(options) {
        this.addTopClass("visible-modal");
        this.setState({modal: options});
    }

    hideModal() {
        this.removeTopClass("visible-modal");
        this.setState({modal: {}});
    }

    // hideSidebar() {
    //     this.setState({
    //         sidebar: {
    //             type: "closed",
    //             show: false,
    //         }
    //     });
    //     this.addTopClass("hidden-sidebar");
    //     this.removeTopClass("hidden-footer");
    //     APP.model.showDoorsClosed(true);
    //     APP.model.selectElement(-1);
    //     this.toggleAdditionalIcons(false);
    // }

    onInfoClick() {
        APP.uiHandler.dialog({
            title: I18N("Coming soon"),
            text: I18N(
                "In Kürze werden Sie hier Ihre Planung in den sozialen Medien teilen können."
            ),
            buttons: [
                {
                    style: "primary",
                    label: I18N("In Ordnung!")
                }
            ]
        });
    }

    onFBShare() {
        /* const toDo = (URL) => {
            const window = this.props.handler.window;
            const myURL = encodeURIComponent(window.location.href);
            const leftX = window.outerWidth / 2 - 200;
            const windowFeatures = "menubar=no,resizable=yes,toolbar=no,scollbars=yes,chrome=yes,centerscreen=yes,width=600,height=800,left=" + leftX;
            setTimeout(() => window.open("https://www.facebook.com/sharer/sharer.php?u=" + myURL + "&amp;src=sdkpreparse",
                "ObjectCode_FB", windowFeatures), 1000);
        }
        this.exportGLB(toDo); */

        APP.uiHandler.dialog({
            title: I18N("Coming soon"),
            text: I18N(
                "In Kürze werden Sie hier Ihre Planung in den sozialen Medien teilen können."
            ),
            buttons: [
                {
                    style: "primary",
                    label: I18N("In Ordnung!")
                }
            ]
        });
    }

    reset() {
        if (APP.resetToConfiguration) {
            APP.arrangement.fromJSON(APP.resetToConfiguration);
        } else {
            APP.arrangement.fromJSON(APP.configuration);
        }
        APP.arrangement.compile();
        APP.model.setDirty();
        this.toggleAdditionalIcons(false);
    }

    undo() {
        APP.undoHandler.undo();
        APP.model.setDirty();
        this.toggleAdditionalIcons(false);
    }

    redo() {
        APP.undoHandler.redo();
        APP.model.setDirty();
        this.toggleAdditionalIcons(false);
    }

    resetCam() {
        STAGE.resetOrbitControl();
        APP.model.setFullCam(APP.model.cameraExtraZoom);
        this.toggleAdditionalIcons(false);
    }

    toggleAdditionalIcons(toggle) {
        if (toggle === true || toggle === false) {
            this.setState({showAdditionalIcons: toggle});
        } else {
            APP.on('changedConfiguration', () => this.updateUI());
            this.setState({showAdditionalIcons: !this.state.showAdditionalIcons});
        }
    }

    updateHeight() {
        this.setState({height: document.documentElement.clientHeight});
    }

    componentWillMount() {
        this.updateHeight();
    }

    componentDidMount() {
        // this.prepareOcAr();

        window.addEventListener('resize', _.debounce(() => {
            this.updateHeight();
        }, 300));
    }

    // prepareOcAr() {
    //     const ocar = this.arRef.current;
    //     ocar.save = (arcallback) => {
    //         this.blur = STAGE.freezeRendererAndBlur();
    //         uiActions._saveAction(
    //             () => {
    //                 this.blur.hideDialog();
    //                 this.updateFromArrangement();
    //                 arcallback();
    //             },
    //             () => {
    //                 APP.uiHandler.dialog({
    //                     title: I18N('saveFailed'),//'Speichern ist fehlgeschlagen!',
    //                     text: I18N('saveFailedText'),//'Wir konnten Ihren Schrank nicht speichern.',
    //                     buttons: [{ style: 'primary', label: I18N('OK') }]
    //                 });
    //             }
    //         );
    //     }
    //     ocar.augmentedReality = {
    //         object3d: APP.arrangement.object3d,
    //         instancesToBeHidden: [InterieurDragBox, Fach],
    //         onSuccess: () => {
    //
    //         },
    //         before: () => {
    //             APP.arrangement.object3d.scale.multiplyScalar(0.01);
    //         },
    //         after: () => {
    //             APP.arrangement.object3d.scale.multiplyScalar(100);
    //             STAGE.renderSceneOnce();
    //         },
    //         projectName: "ocschrank"
    //     }
    //     ocar.arTitle = "ObjectCode Schrankkonfigurator";
    // }

    componentDidUpdate() {
        window.addEventListener('resize', _.debounce(() => {
            this.updateHeight();
        }, 300));
        // this.arRef.current.configuration=APP.configuration.Code;
    }

    getLogoUrl() {
        // console.log('*backto',Urls.urlParam('backto'));
        return (Urls.urlParam('backto') ?? APP.settings.logo_url).replace("{Code}",APP.configuration.Code);
    }

    render() {
        return (
            <div
                id="cfg-container"
                className={this.state.topClasses.join(" ")}
                style={{height: this.state.height}}
            >
                <div className="main-div">
                    {/* Header */}
                    <header id="header">
                        <div className="head-child left no-mobile">
                            <div className="logo">
                                <a href={this.getLogoUrl()}>
                                    <img
                                        className="logoImg"
                                        src={
                                            SETTINGS.wkfgContentBaseUrl + "img/logo.svg"
                                        }
                                    />
                                </a>
                            </div>
                        </div>
                        {this.state.info && (
                            <div className="head-child middle">
                                <div className="title">{this.state.info}</div>
                            </div>
                        )}
                        <div className="head-child right no-tablet">
                            {/*<div className="arWrapper">*/}
                            {/*<oc-ar ref={this.arRef}>*/}
                            {/*<button slot="icon" className="icon-text">*/}
                            {/*<span className="icon ar" title={I18N("In AR anzeigen")} />*/}
                            {/*</button>*/}
                            {/*</oc-ar>*/}
                            {/*</div>*/}
                            <button
                                className="icon reload"
                                onClick={() => this.reset()}
                                title={I18N("Alles zurücksetzen")}
                            />
                            <button
                                className="icon arrow-left"
                                onClick={() => this.undo()}
                                title={I18N("Widerrufen")}
                            />
                            <button
                                className="icon arrow-right"
                                onClick={() => this.redo()}
                                title={I18N("Wiederholen")}
                            />
                            <button
                                className="icon reset-camera"
                                onClick={() => this.resetCam()}
                                title={I18N("Kamera zentrieren")}
                            />
                            <div
                                className={"door-button div-button icon icon-with-text " + (APP.arrangement.doorsClosed ? 'door-closed' : 'door-open')}
                                onClick={() => APP.model.showDoorsClosed(!APP.arrangement.doorsClosed)}>
                                <span className="icon-text-bordered">
                                {(APP.arrangement.doorsClosed ? I18N("Türen öffnen") : I18N("Türen schliessen"))}
                                </span>
                            </div>
                        </div>

                    </header>
                    {/* End: Header */}
                    {/* ================================== */}
                    {/* Main */}
                    <main role="main">
                        <Sidebar
                            state={this.state.sidebar}
                            model={this.state.model}
                        />
                        {/* Main: Content */}
                        <div style={{height: "100%"}}
                             className="wardrobe-wrapper threejsRenderer dragdrop"
                        >
                            <div className="mobile-price-wrapper">
                                <div className="price-wrapper">
                                    <div className="price-inner">
                                        <div className="price">
                                            {Helper.formatMoney(APP.arrangement.preis)}
                                        </div>
                                        <div className="shipment">
                                            {I18N("Lieferung DE")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End: Main: Content */}
                    </main>
                    <Modal
                        title={this.state.modal.title}
                        text={this.state.modal.text}
                        buttons={this.state.modal.buttons}
                        onClose={() => {
                            this.hideModal()
                            if (this.state.modal.onClose) this.state.modal.onClose();
                        }}
                    />
                    {/* End: Main */}
                </div>
                {/* ================================== */}
                {/* Footer */}
                <footer className="footer">
                    <div className="inner-footer">
                        <div className="group left no-tablet-small">
                        </div>

                        <div className="group center">
                            <SidebarMenuItem name="korpus" label={I18N("Korpus")}
                                             image={this.asset("img/Korpus_01.svg")} doorsClosed={true}/>
                            <SidebarMenuItem name="einbauten" label={I18N("Ausstattung")}
                                             image={this.asset("img/Ausstattung_01.svg")} doorsClosed={false}/>
                            {!APP.arrangement.isShojituerInnen() && (
                                <SidebarMenuItem name="tueren" label={I18N("Türen")}
                                                 image={this.asset("img/Tueren_01.svg")} doorsClosed={true}/>
                            )}
                            <SidebarMenuItem name="griffe" label={I18N("Griffe")}
                                             image={this.asset("img/Griffe_01.svg")} doorsClosed={true}/>
                            <SidebarMenuItem name="dekore" label={I18N("Farben")}
                                             image={this.asset("img/Farben_01.svg")} doorsClosed={true}/>
                        </div>
                        <div className="group right noshrink">
                            <div className="price-wrapper no-mobile no-tablet-small">
                                <div className="price-inner">
                                    <div className="price">
                                        {Helper.formatMoney(APP.arrangement.preis)}
                                    </div>
                                    <div className="shipment">
                                        {I18N("Lieferung DE")}
                                    </div>
                                </div>
                            </div>
                            <div className="image-text stop-select footer-primary" style={{width: "100%"}}
                                 onClick={() => this.showSidebar("stammdaten")}>
                                <div className="image no-pointer"><img className="footer-img"
                                                                       src={this.asset("img/shopping-cart-solid.svg")}/>
                                </div>
                                {I18N("Warenkorb")}
                            </div>
                        </div>
                    </div>
                </footer>
                {/* END: Footer */}
            </div>
        );
    }
}
